export const paths = {
  freecourse: "/freecourse",
  masterclass: "/masterclass",
  masterclassojt: "/masterclassojt",
  learningpath: "/learningpath",
  prakerja: "/prakerja",
  portofolio: "/portofolio",
  kampusmerdeka: "/kampusmerdeka",
  internationalcertification: "/internationalcertification",
  nationalcertification: "/nationalcertification",
  testimonial: "/testimonial",
  collaboration: "/colaboration",

  //baru
  login: "/login",
  register: "/signup",
  healthycourse: "/healthycourse",
  healthyclass: "/healthyclass",
  healthyclassojt: "/healthyclassojt",
  corporatetrainingclass: "/corporatetraining",
  udemy: "/udemy",
  sertifikasibnsp: "/sertifikasibnsp",
  sertifikasiinternasional: "/sertifikasiinternasional",
  gallery: "/gallery",
};
